<div class="edit-request-dialog p-4 bg-white rounded-4" style="max-width: 555px; width: 100%;">
  <!-- Header -->
  <div class="dialog-header d-flex align-items-center justify-content-between mb-4 pb-3 border-bottom">
    <div class="d-flex align-items-center gap-3">
      <div class="dialog-header-icon">
        <mat-icon>assignment</mat-icon>
      </div>
      <div>
        <h3 class="dialog-title mb-0 fw-bold">Edit Request</h3>
        <p class="dialog-subtitle mb-0">Update ticket status, cost, and assignment details.</p>
      </div>
    </div>
    <button type="button" mat-icon-button class="dialog-close-btn flex-shrink-0" (click)="closeDialog()" aria-label="Close">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div mat-dialog-content class="dialog-content">
    <mat-progress-bar *ngIf="loading || submitting" mode="indeterminate"></mat-progress-bar>

    <div *ngIf="loading" class="loading-wrap">
      <mat-spinner diameter="50"></mat-spinner>
    </div>

    <form [formGroup]="editRequestForm" class="request-form" *ngIf="!loading">
      <!-- Request Details -->
      <div class="form-section">
        <div class="dialog-section-bar mb-3">
          <div class="section-icon-circle">
            <mat-icon>assignment</mat-icon>
          </div>
          <h4 class="section-bar-title mb-0">Request Details</h4>
        </div>

        <div class="form-row">
          <div class="form-group form-group--full">
            <label for="issue-description">Issue Description</label>
            <div class="form-field">
              <textarea
                id="issue-description"
                class="w-100"
                formControlName="description"
                placeholder="Enter issue description"
                rows="3">
              </textarea>
            </div>
          </div>
        </div>

        <div class="form-row">
          <div class="form-group" [class.form-group--full]="!showSubCategory">
            <label for="category-select">Category</label>
            <div class="form-field">
              <app-searchable-dropdown
                id="category-select"
                class="w-100"
                formControlName="issue_category_id"
                [options]="categoryList | searchableOptions:'issue_category':'issue_category_id'"
                placeholder="Select category">
              </app-searchable-dropdown>
            </div>
          </div>

          <div class="form-group" *ngIf="showSubCategory">
            <label for="subcategory-select">Sub Category</label>
            <div class="form-field">
              <app-searchable-dropdown
                id="subcategory-select"
                class="w-100"
                formControlName="issue_sub_category_id"
                [options]="subCategoryList | searchableOptions:'issue_category':'issue_category_id'"
                placeholder="Select sub category">
              </app-searchable-dropdown>
            </div>
          </div>
        </div>

        <div class="form-row">
          <div class="form-group">
            <label for="priority-select">Priority</label>
            <div class="form-field">
              <app-searchable-dropdown
                id="priority-select"
                class="w-100"
                formControlName="priority_id"
                [options]="priorityList | searchableOptions:'priority':'priority_id'"
                placeholder="Select priority">
              </app-searchable-dropdown>
            </div>
          </div>

          <div class="form-group">
            <label for="status-select">Status</label>
            <div class="form-field">
              <app-searchable-dropdown
                id="status-select"
                class="w-100"
                formControlName="status"
                [options]="statusList | searchableOptions:'status':'status_id'"
                placeholder="Select status">
              </app-searchable-dropdown>
            </div>
          </div>
        </div>

        <div class="form-row">
          <div class="form-group">
            <label for="estimated-cost">Estimated Cost</label>
            <div class="form-field">
              <input
                id="estimated-cost"
                class="w-100"
                type="number"
                formControlName="estimated_cost"
                placeholder="Enter estimated cost">
            </div>
          </div>

          <div class="form-group">
            <label>Budget Approved</label>
            <div class="form-field checkbox-field">
              <mat-checkbox formControlName="is_approved">Is Budget Approved?</mat-checkbox>
            </div>
          </div>
        </div>

        <div class="form-row" *ngIf="requestData?.item?.reported_name">
          <div class="form-group form-group--full">
            <label>Reported By</label>
            <div class="info-field">
              {{ requestData.item.reported_name }} on {{ requestData.item.assigned_at }}
            </div>
          </div>
        </div>
      </div>

      <!-- Assignment Details -->
      <div class="form-section">
        <div class="dialog-section-bar mb-3 mt-3">
          <div class="section-icon-circle">
            <mat-icon>person</mat-icon>
          </div>
          <h4 class="section-bar-title mb-0">Assignment Details</h4>
        </div>

        <div class="form-row">
          <div class="form-group">
            <label for="role-select">Role</label>
            <div class="form-field">
              <app-searchable-dropdown
                id="role-select"
                class="w-100"
                formControlName="role_id"
                [options]="roleList | searchableOptions:'role':'role_id'"
                placeholder="Select role">
              </app-searchable-dropdown>
            </div>
          </div>

          <div class="form-group">
            <label for="member-select">Member</label>
            <div class="form-field">
              <app-searchable-dropdown
                id="member-select"
                class="w-100"
                formControlName="assigned_to"
                [options]="allMembers | searchableOptions:'member_name':'user_id'"
                placeholder="Select member">
              </app-searchable-dropdown>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>

  <div class="dialog-actions d-flex justify-content-end gap-2 pt-3 border-top mt-3">
    <button
      type="button"
      class="btn btn-outline-secondary rounded-pill px-4"
      (click)="closeDialog()">
      Cancel
    </button>
    <button
      type="button"
      class="gold-button"
      (click)="onSubmit()"
      [disabled]="editRequestForm.invalid || loading || submitting">
      <span *ngIf="!submitting">Save</span>
      <span *ngIf="submitting">Saving...</span>
    </button>
  </div>
</div>
